// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"268":"Home","313":"Details","419":"InfoCenter","797":"Iframe","842":"List","845":"LiveRoom"}[chunkId] || chunkId) + "." + {"268":"893891f7","313":"7c454a7f","419":"e5807d2c","440":"c7fcc620","492":"4378ee45","797":"76c875f3","842":"1bd727fc","845":"4e53cfec"}[chunkId] + ".js";
};